import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToolService } from '@app/core/services/tool/tool.service';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-action-modal',
  templateUrl: './action-modal.component.html',
  styleUrls: ['./action-modal.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ActionModalComponent implements OnInit {

  faCheckCircle = faCheckCircle;
  @Input() type: string;

  constructor(
    private modalService: ModalController,
    public toolService: ToolService
  ) { }

  ngOnInit() {/* empty */}

  close = () => {
    this.modalService.dismiss();
  }
}
